// extracted by mini-css-extract-plugin
export const root = "header-module--root--1djVM";
export const branding = "header-module--branding--2G6dQ";
export const toggleNavButton = "header-module--toggleNavButton--IUshU";
export const icon = "header-module--icon--2GO4e";
export const active = "header-module--active--2xuFW";
export const overlay = "header-module--overlay--1fJD9";
export const nav = "header-module--nav--2EwEv";
export const menuOpen = "header-module--menuOpen--3bK6b";